import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "../../fxms/windows/FxWindows";

/*관리자> 가입승인 상세*/
export const UI_5_3_CU = (props) => {
  const [selectedData, setSelectedData] = useState({});
  const [procRsn, setProcRsn] = useState('');

  useEffect(() => {    
    setSelectedData(props.selectedData);
  }, [props.selectedData]);

  const onApprove = async () => {
    if (!procRsn) {
      FxWindow.alert("처리사유를 입력해주세요." , true);
      return;
    }

    const params = {
      applyUserId: selectedData.applyUserId,
      procStCd: 'A',
      procRsn: procRsn
    };

    try {
      await FxmsData.PUT(`fxUrUser/new/${selectedData.applyUserId}`, params);
      FxWindow.alert("승인 처리되었습니다.", () => {
        onList();
      });
    } catch (e) {
      console.log("승인 처리 실패", e);
      FxWindow.alert("승인 처리에 실패했습니다." , true);
    }
  };

  const onReject = async () => {
    if (!procRsn) {
      FxWindow.alert("처리사유를 입력해주세요." , true);
      return;
    }

    const params = {
      applyUserId: selectedData.applyUserId,
      procStCd: 'R',
      procRsn: procRsn
    };

    try {
      await FxmsData.PUT(`fxUrUser/new/${selectedData.applyUserId}`, params);
      FxWindow.alert("반려 처리되었습니다.", () => {
        onList();
      });
    } catch (e) {
      console.log("반려 처리 실패", e);
      FxWindow.alert("반려 처리에 실패했습니다.", true);
    }
  };

  const onList = () => {
    if (props.refershGridData) {
      props.refershGridData();
    }
    if (props.onCloseBtnClick) {
      props.onCloseBtnClick();
    }
  };

  const onChangeProcRsn = (e) => {
    setProcRsn(e.target.value);
  };

  const formatDateTime = (dateTimeStr) => {
    // null, undefined, 빈 문자열 체크
    if (!dateTimeStr) return '-';
    
    // 문자열로 변환
    const strDateTime = String(dateTimeStr);
    
    // 길이가 14자리가 아닌 경우 원본 반환
    if (strDateTime.length !== 14) return dateTimeStr;
  
    try {
      return `${strDateTime.substring(0,4)}-${strDateTime.substring(4,6)}-${strDateTime.substring(6,8)} ${strDateTime.substring(8,10)}:${strDateTime.substring(10,12)}:${strDateTime.substring(12,14)}`;
    } catch (e) {
      console.log('날짜 포맷팅 에러:', e);
      return dateTimeStr; // 에러 발생 시 원본 반환
    }
  }

  return (
    <div>
      <div className="FxDataEdit">
        <table className="table">
          <colgroup>
            <col style={{ width: "15%" }} />
            <col style={{ width: "35%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "35%" }} />
          </colgroup>
          <tbody>
            <tr>
              <th>신청사용자ID</th>
              <td>
                <input
                  type="text"
                  value={selectedData.applyUserId || ''}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
              <th>신청사용자명</th>
              <td>
                <input
                  type="text"
                  value={selectedData.applyUserName || ''}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th>신청전화번호</th>
              <td>
                <input
                  type="text"
                  value={selectedData.applyTelNo || ''}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
              <th>신청메일</th>
              <td>
                <input
                  type="text"
                  value={selectedData.applyUserMail || ''}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th>신청일시</th>
              <td>
                <input
                  type="text"
                  value={formatDateTime(selectedData.regDtm) || ''}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
              <th>신청메모</th>
              <td>
                <input
                  type="text"
                  value={selectedData.applyMemo || ''}
                  disabled={true}
                  style={{ width: '100%', height: '30px' }}
                />
              </td>
            </tr>
            <tr>
              <th><FxLabelBase>처리사유</FxLabelBase></th>
              <td colSpan="3">
                <textarea
                  value={procRsn}
                  onChange={onChangeProcRsn}
                  style={{ width: '100%', height: '60px' }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="FxCrudToolbar">
        <div className="FxFilterCenter">
          <FxButtonBase key={uuidv4()} name="click" onClick={onList} text="취소" />
        </div>
        <div className="FxFilterRight">
          <FxButtonBase 
            key={uuidv4()} 
            name="click" 
            onClick={onApprove} 
            text="승인" 
            style={{ backgroundColor: '#4CAF50' }}
          />
          <FxButtonBase 
            key={uuidv4()} 
            name="click" 
            onClick={onReject} 
            text="반려" 
            style={{ backgroundColor: '#f44336' }}
          />
        </div>
      </div>
    </div>
  );
};